export enum VoicesCampaignStatus {
  ACTIVE = 0,
  CLOSED = 1,
}

export enum VoicesSearchMode {
  CLAUDE_NATIVE = 0,
  QMS_AGENT = 1,
}

export enum VoicesTopicOrigin {
  RSS = 0,
  WEB = 1,
  MANUAL = 2,
  AGENT = 3,
}

export enum VoicesTopicStatus {
  NEW = 0,
  USED = 1,
  DISMISSED = 2,
}

export enum VoicesPostState {
  DRAFT = 0,
  IN_APPROVAL = 1,
  SCHEDULED = 2,
  PUBLISHED = 3,
  FAILED = 4,
}

export enum VoicesCheckSeverity {
  BLOCK = 0,
  WARN = 1,
}
